import { OnboardingRFIFormSavePayload } from 'commons/types/DTO/commons/webpagesOnboardinForm'
import { YesNoRadioGroup } from 'commons/types/enums'

import { OnboardingFormsData, OnboardingProxyWebpageData } from '../../../types/state'
import { mapATMGeneralInfoForm } from './mappers/mapATMGeneralInfoForm'
import { mapATMServicesForm } from './mappers/mapATMServicesForm'
import { mapAccountDetailsForm } from './mappers/mapAccountDetailsForm'
import { mapAnticipatedMonthlyActivityForm } from './mappers/mapAnticipatedMonthlyActivityForm'
import { mapAnticipatedMonthlyActivityNAForm } from './mappers/mapAnticipatedMonthlyActivityNAForm'
import { mapAvailableServicesForm } from './mappers/mapAvailableServicesForm'
import { mapCompanyInformationForm } from './mappers/mapCompanyInformationForm'
import { mapCompanyMailingAddressForm } from './mappers/mapCompanyMailingAddressForm'
import { mapCompanyPhysicalAddressForm } from './mappers/mapCompanyPhysicalAddressForm'
import { mapContactAdditionalInformationForm } from './mappers/mapContactAdditionalInformationForm'
import { mapContactDetailsForm } from './mappers/mapContactDetailsForm'
import { mapLicenseAddressInformationForm } from './mappers/mapLicenseAddressInformationForm'
import { mapLicenseDetailsForm } from './mappers/mapLicenseDetailsForm'
import { mapMerchantQuestionnaireForm } from './mappers/mapMerchantQuestionnaireForm'
import { mapProfessionalPartnershipForm } from './mappers/mapProfessionalPartnershipForm'
import { mapQuestionnaireForm } from './mappers/mapQuestionnaireForm'
import { mapRoleInformationForm } from './mappers/mapRoleInformationForm'

export const mapFormValuesForSave = ({
  applicationId,
  formValue,
  proxyWebpageData: { updatedAt }
}: {
  applicationId: number
  formValue: OnboardingFormsData
  proxyWebpageData: OnboardingProxyWebpageData
}): OnboardingRFIFormSavePayload => {
  const companies = formValue.companiesFormValues

  return {
    id: applicationId,
    rfiInfo: {
      relationships: companies.map((companyForms) => {
        const questionnaire = {
          ...companyForms.questionnaire.formValues,
          useDBA: companyForms.companyInformation.formValues.useDBA
        }

        const companyInformation = {
          ...companyForms.companyInformation.formValues,
          DBA:
            companyForms.companyInformation.formValues.useDBA === YesNoRadioGroup.YES
              ? companyForms.companyInformation.formValues.DBA
              : ''
        }

        return {
          questionnaire: {
            ...mapQuestionnaireForm(questionnaire),
            ...mapProfessionalPartnershipForm(companyForms.professionalPartnerships.formValues),
            ...mapATMGeneralInfoForm(companyForms.atmGeneralInfo.formValues),
            ...mapAvailableServicesForm(companyForms.availableServices.formValues),
            ...mapAnticipatedMonthlyActivityNAForm(companyForms.anticipatedMonthlyActivityNA.formValues),
            ...mapAnticipatedMonthlyActivityForm(companyForms.anticipatedMonthlyActivity.formValues),
            ...mapMerchantQuestionnaireForm(companyForms.companyMerchantQuestionnaire.formValues),
            ATMs: companyForms.atms.map((atmFormData) => ({
              ...mapATMServicesForm(atmFormData.atmServices.formValues)
            }))
          },
          ...mapCompanyInformationForm(companyInformation),
          ...mapAccountDetailsForm(companyForms.companyAccountDetails.formValues),
          ...mapCompanyPhysicalAddressForm(companyForms.physicalAddress.formValues),
          ...mapCompanyMailingAddressForm(companyForms.mailingAddress.formValues),
          licenses:
            companyForms.companyAccountDetails.formValues.businessType !== 'mrb'
              ? []
              : companyForms.licenses.map((licenseItemForms) => ({
                  ...mapLicenseDetailsForm(licenseItemForms.details.formValues),
                  ...mapLicenseAddressInformationForm(licenseItemForms.addressInformation.formValues)
                })),
          contacts: companyForms.contacts.map((contactItemForms) => ({
            ...mapContactDetailsForm(contactItemForms.details.formValues),
            ...mapRoleInformationForm(contactItemForms.roleInformation.formValues),
            ...mapContactAdditionalInformationForm(contactItemForms.contactAdditionalInformation.formValues)
          }))
        }
      })
    },
    updatedAt
  }
}
